<template>
  <el-row>
    <table-template :queryParams="queryParams" actionUrl="/businessIntranet/findJoinGroupInfoForAdminList.action"
                    ref="joinGroupManagementTable">
      <template slot="search">
        <el-row>
          <el-form :inline="true" class="demo-form-inline">
            <el-form-item>
              <el-select v-model="queryParams.status" :clearable="true" :filterable="true" placeholder="状态">
                <el-option :value="1" label="未进群"></el-option>
                <el-option :value="3" label="待拉群"></el-option>
                <el-option :value="2" label="已进群"></el-option>

              </el-select>
            </el-form-item>
            <el-form-item>
              <el-date-picker
                  @change="onDateTimeChange"
                  end-placeholder="结束日期"
                  range-separator="至"
                  start-placeholder="开始日期"
                  type="datetimerange"
                  v-model="queryParams.startEndTime">
              </el-date-picker>
            </el-form-item>
            <el-form-item>
              <el-input placeholder="搜索群名、用户手机号" v-model="queryParams.keyword"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button @click="$refs.joinGroupManagementTable.search()" type="primary">搜索</el-button>
            </el-form-item>
          </el-form>
        </el-row>

      </template>
      <template slot="item">
        <el-table-column
            label="用户信息"
            prop="name">
          <template scope="scope">
            {{scope.row.name}}-{{scope.row.phone}}
          </template>
        </el-table-column>
        <el-table-column
            label="维护人"
            prop="maintenanceName">
        </el-table-column>
        <el-table-column
            label="群名"
            prop="chatName">
        </el-table-column>

        <el-table-column
                label="成员人数"
                prop="memberCount">
        </el-table-column>

        <el-table-column
                label="类型"
                prop="regionTypeName">
        </el-table-column>

        <el-table-column
                label="状态"
                width="120px"
        >
          <template slot-scope="scope">

            <el-dropdown trigger="click"  width="100px">
              <el-button class="el-dropdown-link" size="mini" type="primary">
                {{ scope.row.status|statusFilter }}<i class="el-icon-caret-bottom el-icon--right" style="color:#FFF"></i>
              </el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item @click.native.prevent="changeJoinStatus(scope.row.id,1)" >未进群</el-dropdown-item>

                <el-dropdown-item @click.native.prevent="changeJoinStatus(scope.row.id,3)" >待拉群</el-dropdown-item>

                <el-dropdown-item @click.native.prevent="changeJoinStatus(scope.row.id,2)" >已进群</el-dropdown-item>

              </el-dropdown-menu>
            </el-dropdown>

          </template>
        </el-table-column>

        <el-table-column
                label="创建时间"
                prop="createTime">
        </el-table-column>
        <el-table-column
                label="操作">
          <template scope="scope">
            <el-button type="text" size="mini"  @click="$router.push({name:'编辑商家群', query: { id: scope.row.id,businessGroupId:scope.row.businessGroupId }})">修改商家群</el-button>
          </template>
        </el-table-column>

      </template>
    </table-template>
  </el-row>
</template>

<script>
import TableTemplate from '@/components/TableTemplate'
import BasicPager from '@/mixins/BasicPager'
import BasicModel from '@/framework/basic/BasicModel'
export default {
  components: {
    TableTemplate
  },
  extends: BasicPager,
  name: 'joinGroupList',
  data: function () {
    return {
      queryParams: { status: 1 }
    }
  },
  watch: {
    'queryParams.status': function () {
      this.$refs.joinGroupManagementTable.search()
    }
  },
  methods: {
    changeJoinStatus (id, status) {
      let _this = this
      let params = { id: id, status: status }
      let listener = {
        success: function (dataInfo) {
          _this.$message({
            type: dataInfo.success ? 'success' : 'error',
            message: dataInfo.errMsg
          })
          _this.$refs.joinGroupManagementTable.search()
        }

      }

      BasicModel.post(_this, '/businessIntranet/changeJoinStatus.action', params, listener)
    },
    onDateTimeChange (dates) {
      if (dates && dates.length === 2) {
        this.queryParams.startTime = dates[0].getTime()
        this.queryParams.endTime = dates[1].getTime()
      } else {
        this.queryParams.startTime = null
        this.queryParams.endTime = null
      }
      this.$refs.joinGroupManagementTable.search()
    }
  },
  filters: { statusFilter: function (val) {
    let str = '非法值'
    switch (val) {
      case 1:
        str = '未进群'
        break
      case 2:
        str = '已进群'
        break
      case 3:
        str = '待拉群'
        break
    }
    return str
  } }
}
</script>

<style scoped>
</style>
